import { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { APIResponseCode, Constants } from 'common/constants';
import { PATHS } from '@routing/routes';
import { AccountSelector } from '../store/AccountSelector';
import { AccountActions } from '../store/AccountSlice';
import { ResetPasswordBusiness, ValidateResetPasswordOTP } from '../business/AccountBusiness';
export const ResetPasswordSendCode = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const accountState = useSelector(AccountSelector);
  const dispatch = useDispatch();
  const [showOtpError, setShowOtpError] = useState(false);

  const onFinish = async (values: any) => {
    setShowOtpError(false);
    setIsRResendNewOTP(false);
    if (accountState.ResetPasswordResponseViewModel) {
      const response = await dispatch(
        ValidateResetPasswordOTP({
          Id: accountState.ResetPasswordResponseViewModel.Id,
          OTP: values.OTP,
        })
      );
      if (response.toString() === APIResponseCode.SUCCESS) {
        history.push(PATHS.PasswordResetOTP.path);
      } else {
        setShowOtpError(true);
      }
    }
  };

  const [timer, setTimer] = useState(60); // countdown in seconds
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [isResendNewOTP, setIsRResendNewOTP] = useState(false);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isResendDisabled) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setIsResendDisabled(false);
            setIsRResendNewOTP(false);
            return 60;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isResendDisabled]);

  const handleResendOtp = async () => {
    if (accountState.ResetPasswordResponseViewModel?.Username) {
      await dispatch(ResetPasswordBusiness(accountState.ResetPasswordResponseViewModel?.Username));
    }
    setShowOtpError(false);
    setIsResendDisabled(true);
    setIsRResendNewOTP(true);
    form.setFieldsValue({ OTP: '' });
  };

  const onBack = () => {
    // alert('ss');
    dispatch(AccountActions.resetState());
    dispatch(AccountActions.SetResetPasswordEmail(''));
    dispatch(AccountActions.SetIsValidEmailResetPassword(true));
    history.push(PATHS.ResetPassword.path);
  };

  return (
    <div className="App">
      <Row justify="center" align="middle">
        <h4>Reset password</h4>
      </Row>

      <Form name="senderForm" onFinish={onFinish} layout="vertical" form={form}>
        <>
          <Row justify="center" align="middle">
            <Col xs={24} sm={20} md={12} lg={8} xl={8}>
              {!accountState.ResetPasswordResponseViewModel?.IsEmailOTP && (
                <>
                  <Form.Item
                    className="mtb-0"
                    label={<>{accountState.ResetPasswordResponseViewModel?.Content}</>}
                    name="OTP"
                    rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
                  >
                    <Input maxLength={6} size="large" placeholder=" Enter your one-time code" />
                  </Form.Item>
                  {showOtpError && (
                    <>
                      <label className="ErrorColor small">
                        Invalid or expired one-time code. Please request a new one.
                      </label>
                      <br />
                    </>
                  )}
                  {isResendNewOTP && (
                    <>
                      <label className="textColorPrimary small">
                        A new one-time code has been sent to your mobile. Please try again.
                      </label>
                      <br />
                    </>
                  )}
                  <br />
                  <div>
                    <Button
                      // loading={bookingState.submitStatus === OperationStatus.pending}
                      className="nextSenderBtn"
                      size="large"
                      type="primary"
                      htmlType="submit"
                    >
                      {Constants.BTN_CONFIRM}
                    </Button>
                    <Button className="prevSenderBtn " size="large" type="default" onClick={onBack}>
                      {Constants.BTN_BACK}
                    </Button>
                  </div>

                  <br />
                  <br />
                  <br />
                  <Form.Item>
                    <div className="right-text">
                      {isResendDisabled ? `Resend new OTP in ${timer}s` : <a onClick={handleResendOtp}>Resend OTP</a>}
                    </div>
                  </Form.Item>
                </>
              )}
              {accountState.ResetPasswordResponseViewModel?.IsEmailOTP && (
                <>
                  <label>
                    {' '}
                    If an account exists for {accountState.ResetPasswordEmail}, you will get an email with instructions
                    on resetting your password. If it doesn’t arrive, be sure to check your spam folder.
                  </label>
                </>
              )}
            </Col>
          </Row>
        </>

        <br />
      </Form>
    </div>
  );
};
